import BounceLoader from 'react-spinners/BounceLoader';

export default function Loading() {
  return <BounceLoader color='#7C3AED' />;
}
